import React from 'react';

import classNames from 'classnames';
import { BookOpenIcon } from '@ergeon/icons/hero/mini';

import { WIKI_TITLE } from '../constants';
import { getModifierKey } from '../keyboard';
import PaletteTrigger from '../PaletteTrigger';

const EYEBROW_CLASSES = classNames(
  'flex items-center gap-2 paragraph-3 font-semibold uppercase tracking-wider',
  'text-blue-600 dark:text-blue-300',
);

const TITLE_CLASSES = 'heading-2 text-gray-900 md:heading-1 dark:text-white';

const LandingHeader = () => (
  <header className="flex max-w-3xl flex-col gap-4">
    <p className={EYEBROW_CLASSES}>
      <BookOpenIcon aria-hidden="true" className="size-4" />
      {WIKI_TITLE}
    </p>
    <h1 className={TITLE_CLASSES}>How can we help?</h1>
    <p className="font-base text-lg text-gray-700 dark:text-gray-300">
      The documentation and playbooks for the company and each business function.
      {` Press ${getModifierKey()} K on any page to search.`}
    </p>
    <PaletteTrigger label="Search the wiki" size="large" />
  </header>
);

export default LandingHeader;
